export function nl2br(string: string) {
    return string.replace(/\n|\\n/g, '<br/>');
}
